import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import JoinTeam from '../views/joinTeam.vue'
import CreateTeam from '../views/CreateTeam.vue'
import MyTeam from '../views/myTeam.vue'
import Joinpreview from '../views/joinpreview'
import TeamDetail from '../views/teamdetail'
import Tutorial from '../views/tutorial'
import Background from '../views/Background'

Vue.use(VueRouter)
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      title: '证件照采集'
    },
    component: Home
  },
  {
    path: '/createTeam',
    name: 'CreateTeam',
    meta: {
      title: '创建团体'
    },
    component: CreateTeam
  },
  {
    path: '/myTeam',
    name: 'MyTeam',
    meta: {
      title: '我创建的团体'
    },
    component: MyTeam
  },
  {
    path: '/joinTeam',
    name: 'JoinTeam',
    meta: {
      title: '我参与的团体'
    },
    component: JoinTeam
  },
  {
    path: '/Joinpreview',
    name: 'Joinpreview',
    meta: {
      title: '证件照预览'
    },
    component: Joinpreview
  },
  {
    path: '/TeamDetail',
    name: 'TeamDetail',
    component: TeamDetail
  },
  {
    path: '/Tutorial',
    name: 'Tutorial',
    meta: {
      title: '操作指南'
    },
    component: Tutorial
  },
  {
    path: '/Background',
    name: 'Background',
    component: Background
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
